import { render, staticRenderFns } from "./stat-month-list.vue?vue&type=template&id=b5f70152&"
import script from "./stat-month-list.vue?vue&type=script&lang=js&"
export * from "./stat-month-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "stat-month-list.vue"
export default component.exports